module.exports = __webpack_public_path__ + "static/media/cloudradar.9fdd89af.png";